import numSpinner from './numSpinner';
export default numSpinner;



// WEBPACK FOOTER //
// ./src/components/numSpinner/index.js